import {fontWeight, colorPalette, fontSize} from '../../../config';
import {
	cardTitleProps,
	ulsTitleProps,
	ulsContentProps,
	tdProps,
	thProps,
} from '../../common';

export const summary = {
	title: {
		text: {...cardTitleProps, children: '대회개요'},
	},
	uls: [
		{
			listStyle: 'title',
			items: [
				{
					title: {...ulsTitleProps, children: '대회명'},
					content: {
						...ulsContentProps,
						children: '제1회 구례지리산봄길마라톤대회',
						fontWeight: fontWeight.bold,
					},
				},
				{
					title: {...ulsTitleProps, children: '일시'},
					content: {
						...ulsContentProps,
						children: '2026년 5월 2일 (토)',
					},
				},
				{
					title: {...ulsTitleProps, children: '접수마감'},
					contents: [
						{
							...ulsContentProps,
							children: `선착순 마감(4월 17일 최종마감)`,
							fontWeight: fontWeight.bold,
						},
						{
							...ulsContentProps,
							children:
								'하프코스 1,000명\n10km 1,500명\n5km 1,500명',
						},
					],
				},
				{
					title: {...ulsTitleProps, children: '장소'},
					content: {
						...ulsContentProps,
						children: '구례군 공설운동장',
					},
				},
				{
					title: {...ulsTitleProps, children: '종목'},
					content: {
						...ulsContentProps,
						children: '하프코스, 10km, 5km',
					},
				},
				{
					title: {...ulsTitleProps, children: '참가비'},
					content: {
						...ulsContentProps,
						children: `- 하프코스(35,000원)\n- 10km코스(35,000원)\n- 5km코스(20,000원)`,
					},
				},
				{
					title: {...ulsTitleProps, children: '참가자격'},
					contents: [
						{
							...ulsContentProps,
							children: '나이제한 없으며, 신체 건강한 남/여',
						},
						{
							...ulsContentProps,
							children: `대한육상경기연맹 등록선수 및 선수등록 말소 후 2년 경과되지 않은 자는 참가할 수 없습니다.`,
							fontWeight: fontWeight.bold,
						},
					],
				},
				{
					title: {...ulsTitleProps, children: '문의'},
					content: {
						...ulsContentProps,
						children: `사무국 연락처 : 061-921-6600\n사무국 운영시간/09:00~18:00(월~금), 점심시간/12:00~13:00`,
					},
				},
				{
					title: {...ulsTitleProps, children: '주최/주관'},
					content: {
						...ulsContentProps,
						children: '오마이뉴스 광주전라본부/구례군육상연맹',
					},
				},

				{
					title: {...ulsTitleProps, children: '후원'},
					content: {
						...ulsContentProps,
						children: '구례군',
					},
				},
			],
		},
	],
};

export const way = {
	title: {
		text: {...cardTitleProps, children: '신청방법'},
	},
	uls: [
		{
			listStyle: 'title',
			items: [
				{
					title: {...ulsTitleProps, children: '인터넷'},
					content: {
						...ulsContentProps,
						children: '인터넷으로만 접수 http://www.grrun.kr',
						fontWeight: fontWeight.bold,
					},
				},
				// {
				// 	title: {...ulsTitleProps, children: '현장접수'},
				// 	content: {
				// 		...ulsContentProps,
				// 		children: `현장접수는 종목별 선착순 30명으로 제한합니다.\n※ 현장접수자는 시상에서 제외됩니다.`,
				// 	},
				// },
			],
		},
	],
};

export const feeTextProps = {
	base: {
		fontWeight: fontWeight.medium,
		color: colorPalette.primary,
		fontSize: {desktop: fontSize.xl},
	},
	accent: {
		fontWeight: fontWeight.bold,
		color: colorPalette.primary,
		fontSize: {desktop: fontSize.xl3},
	},
};

export const fee = {
	display: {
		desktop: 'table',
		tablet: 'table',
		mobile: 'none',
	},
	title: {
		text: {...cardTitleProps, children: '참가비 및 입금계좌'},
	},
	table: {
		display: {
			desktop: 'table',
			tablet: 'table',
			mobile: 'none',
		},
		scroll: false,
		ths: [
			{...thProps, children: '종목'},
			{...thProps, children: '참가비'},
			{...thProps, children: '입금계좌'},
		],
		trs: [
			[
				{...tdProps, children: '하프코스'},
				{...tdProps, children: '35,000'},
				{
					...tdProps,
					childrens: [
						{
							...feeTextProps.base,
							children:
								'입금은행 : 광주은행 / 예금주 : (주)오마이뉴스광주전라본부',
						},
						{
							...feeTextProps.accent,
							children: '1107-021-927109',
						},
					],
					rowSpan: '3',
				},
			],
			[
				{...tdProps, children: '10km코스'},
				{...tdProps, children: '35,000'},
			],
			[
				{...tdProps, children: '5km코스'},
				{...tdProps, children: '20,000'},
			],
		],
	},
};

export const mobileFee = {
	display: {
		desktop: 'none',
		tablet: 'none',
		mobile: 'table',
	},
	title: {
		text: {...cardTitleProps, children: '참가비'},
	},
	table: {
		display: {
			desktop: 'none',
			tablet: 'none',
			mobile: 'table',
		},
		scroll: false,
		ths: [
			{...thProps, children: '종목'},
			{...thProps, children: '참가비'},
		],
		trs: [
			[
				{...tdProps, children: '하프코스'},
				{...tdProps, children: '35,000'},
			],
			[
				{...tdProps, children: '10km코스'},
				{...tdProps, children: '35,000'},
			],
			[
				{...tdProps, children: '5km코스'},
				{...tdProps, children: '20,000'},
			],
		],
	},
};

export const mobileDeposit = {
	display: {
		desktop: 'none',
		tablet: 'none',
		mobile: 'table',
	},
	title: {
		text: {...cardTitleProps, children: '입금계좌'},
	},
	table: {
		display: {
			desktop: 'none',
			tablet: 'none',
			mobile: 'table',
		},
		scroll: false,
		ths: [{...thProps, children: '입금계좌'}],
		trs: [
			[
				{
					...tdProps,
					childrens: [
						{...feeTextProps.base, children: '입금은행 : 광주은행'},
						{
							...feeTextProps.base,
							children: '예금주: (주)오마이뉴스광주전라본부',
						},
						{...feeTextProps.accent, children: '1107-021-927109'},
					],
				},
			],
		],
	},
};

export const refundPolicy = {
	title: {
		text: {...cardTitleProps, children: '환불규정'},
	},
	uls: [
		{
			listStyle: 'circle',
			items: [
				{
					content: {
						...ulsContentProps,
						children:
							'입금 확인은 입금 다음 날부터 가능 (신청 후 7일간 미입금 시 접수 자동으로 취소)',
					},
				},
				{
					content: {
						...ulsContentProps,
						children: `본인 실수로 인해 입금 확인이 되지 않을 경우 참가 불가 (10% 공제 후 환불)`,
					},
				},
				{
					content: {
						...ulsContentProps,
						children: `반드시 신청자 본인 명의 입금 (단체는 입금자명에 단체명 표기해 입금)`,
					},
				},
				{
					content: {
						...ulsContentProps,
						children: '선착순 마감 이후 취소나 종목 변경 불가',
					},
				},
				{
					content: {
						...ulsContentProps,
						children:
							'접수마감 전 취소시 10% 공제 후 환불 (환불 소요기간은 약 1 주일 소요)',
					},
				},
				{
					content: {
						...ulsContentProps,
						children:
							'참가자가 본인 이름으로 입금하지 않아 , 입금 확인이 되지 않을 경우 , 참가할 수 없으며 입금 금액의 10% 를 공제한 후 환불 (환불 소요기간은 약 1 주일 소요)',
					},
				},
				{
					content: {
						...ulsContentProps,
						children:
							'배번호와 기념품 등 택배가 발송된 이후, 기상이나 천재 지변, 사회적으로 대회를 개최하기 어려운 분위기로 취소될 경우에는 환불이 불가능하며 택배 발송 이전에는 전액 환불됩니다.',
					},
				},
			],
		},
		// {
		// 	listStyle: 'title',
		// 	items: [
		// 		{
		// 			title: {
		// 				...ulsTitleProps,
		// 				children: '환불 신청 기간',
		// 				type: 'long',
		// 			},
		// 			content: {
		// 				...ulsContentProps,
		// 				children:
		// 					'참가 접수기간 중에만 가능 (참가 접수 마감 후에는 불가능)',
		// 			},
		// 		},
		// 		{
		// 			title: {
		// 				...ulsTitleProps,
		// 				children: '환불 신청방법',
		// 				type: 'long',
		// 			},
		// 			content: {
		// 				...ulsContentProps,
		// 				children: '홈페이지 자유게시판에 비밀글로 직접 신청',
		// 			},
		// 		},
		// 		{
		// 			title: {
		// 				...ulsTitleProps,
		// 				children: '환불액 지급 방법',
		// 				type: 'long',
		// 			},
		// 			content: {
		// 				...ulsContentProps,
		// 				children:
		// 					'개인 계좌를 통한 환불 처리 (환불 신청 후 7일 ~ 10일 소요)',
		// 			},
		// 		},
		// 		{
		// 			title: {
		// 				...ulsTitleProps,
		// 				children: '환불 금액',
		// 				type: 'long',
		// 			},
		// 			content: {
		// 				...ulsContentProps,
		// 				children:
		// 					'참가비의 10%를 제외한 금액 (사무국 운영, 은행 수수료 등 제반 경비)',
		// 			},
		// 		},
		// 	],
		// },
	],
};

export const schedule = {
	title: {
		text: {...cardTitleProps, children: '대회일정'},
	},
	table: {
		ths: [
			{...thProps, children: '일자'},
			{...thProps, children: '시간'},
			{...thProps, children: '내용'},
		],
		trs: [
			[
				{...tdProps, children: '2026년 5월 2일(토)', rowSpan: '10'},
				{...tdProps, children: '07:00'},
				{...tdProps, children: '부스 운영'},
			],
			[
				{...tdProps, children: '07:50'},
				{...tdProps, children: '식전 공연 및 준비 운동'},
			],
			[
				{...tdProps, children: '08:00'},
				{...tdProps, children: '개회식'},
			],
			[
				{...tdProps, children: '08:20'},
				{...tdProps, children: '참가선수, 내빈 출발선 이동'},
			],
			[
				{...tdProps, children: '08:30'},
				{...tdProps, children: '하프 출발'},
			],
			[
				{...tdProps, children: '08:40'},
				{...tdProps, children: '10km코스 출발'},
			],
			[
				{...tdProps, children: '08:50'},
				{...tdProps, children: '5km코스 출발'},
			],
			[
				{...tdProps, children: '10:00'},
				{...tdProps, children: '종목별 시상'},
			],
			[
				{...tdProps, children: '11:30'},
				{...tdProps, children: '폐회'},
			],
		],
		descriptions: [
			{
				content: {
					children: `행사 일정은 현장 상황에 따라 변동될 수 있습니다.`,
				},
			},
		],
	},
};
export const provide = {
	title: {
		text: {...cardTitleProps, children: '참가자 제공품'},
	},
	uls: [
		{
			listStyle: 'circle',
			items: [
				{
					content: {
						...ulsContentProps,
						children:
							'참가자 제공품은 대회 2~3일 전 참가신청시 기재한 주소로 발송됩니다. (단체의 경우 단체장 주소로 한번에 발송)',
					},
				},
				{
					content: {
						...ulsContentProps,
						children:
							'함께 발송되는 기록칩은 배번호에 동봉되어있으니 절대로 버리지 마시고 봉투를 잘 확인하시기 바랍니다.',
					},
				},
				{
					content: {
						...ulsContentProps,
						children:
							'번호표 분실 또는 미지참 시 대회장에서 재발급이 불가능합니다.',
						color: colorPalette.warn,
						fontWeight: fontWeight.bold,
					},
				},
			],
		},
	],
};
export const provideTable = {
	table: {
		scroll: false,
		ths: [
			{...thProps, children: '종목'},
			{...thProps, children: '제공품목'},
		],
		trs: [
			[
				{...tdProps, children: '하프코스\n10km'},
				{
					...tdProps,
					children:
						'기념품, 배번호, 기록칩, 기록증, 메달, 보험, 안내책자, 간식, 먹거리',
				},
			],

			[
				{...tdProps, children: '5km'},
				{
					...tdProps,
					children:
						'기념품, 배번호, 메달, 보험, 안내책자, 간식, 먹거리',
				},
			],
		],

		// descriptions: [
		// 	{
		// 		content: {
		// 			children:
		// 				'택배로 보내드리는 비닐가방은 당일 물품보관을 할 경우 필요합니다. 분실 시 행사장에서 1,000원을 지불하고 구매하셔야 합니다.',
		// 			color: colorPalette.warn,
		// 			fontWeight: fontWeight.bold,
		// 		},
		// 	},
		// ],
	},
};
